module.exports = __webpack_public_path__ + "img/112.32e6a9b3.png";